<template>
  <Dialog
    v-model:visible="showModal"
    :draggable="false"
    :breakpoints="{ '960px': '95vw', '640px': '95vw' }"
    :style="{ width: '65vw', minWidth: '360px' }"
    :modal="true"
    contentStyle=""
    class="dialog"
    @update:visible="onCloseMaterialsModal"
  >
    <template #header>
      <section class="px-8 pb-0 w-full">
        <h4>
          {{
            $t("labels.generic", {
              pt: `Visualizar objetos`,
              en: `View objects`,
            })
          }}
          - {{ learningObjective?.name }}
        </h4>
      </section>
    </template>
    <section v-if="materials?.length > 0">
      <MaterialLoad
        :currentMaterial="
          materials.length > 1 ? materials[indexMaterial] : materials[0]
        "
        :materials="materials"
        :indexMaterial="indexMaterial"
        :maxIndexMaterial="config.maxIndexMaterial"
        :typeModalHeader="config.typeModalHeader"
        :isAdaptativeLearning="isAdaptativeLearning"
        @onChooseMaterial="onChooseMaterial"
        @onDeleteObject="onDeleteObject"
        @onGoToEditObject="onGoToEditObject"
        ref="materialLoad"
      />
    </section>
    <section v-else class="min-h-[600px]">
      <div
        class="w-full min-h-[600px] flex flex-col justify-center items-center space-y-4"
      >
        <img src="@/assets/images/empty/empty-materials.svg" alt="" />
        <p class="font-bold text-gray-700">
          {{
            $t("labels.generic", {
              pt: `Nenhum objeto adicionado`,
              en: `No objects added`,
            })
          }}
        </p>
        <Button
          v-if="user?.role === 'TEACHER'"
          class="btn-outline flex justify-center items-center"
          @click="onGoToObjective()"
        >
          <v-icon name="md-add" class="text-primary-400" />
          {{
            $t("labels.generic", {
              pt: `Adicionar objetos`,
              en: `Add objects`,
            })
          }}</Button
        >
      </div>
    </section>
  </Dialog>
</template>

<script lang="ts">
import { ConfigModal } from "@/models/material.model";
import { User } from "@/models/user.model";
import { GoToRoute } from "@/utils/go-to.util";
import { getUserFromStorage } from "@/utils/user-store.util";
import { defineComponent, PropType } from "vue";

export default defineComponent({
  name: "materialsModal",
  emits: [
    "onChooseMaterial",
    "onCloseMaterialsModal",
    "onGoToObjective",
    "onGoToEditObject",
    "onDeleteObject",
  ],
  props: {
    showMaterialsModal: [Boolean],
    config: {
      type: Object as PropType<ConfigModal>,
      default: new ConfigModal(),
    },
    materials: {
      type: Array as PropType<any>,
    },
    learningObjective: {
      type: Object as PropType<any>,
    },
    userRole: {
      type: String,
    },
    isAdaptativeLearning: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    materials(val) {
      this.indexMaterial = this.config.currentIndex;
    },
  },
  data() {
    return {
      indexMaterial: 0 as number,
      showModal: false as boolean,
    };
  },
  mounted() {
    this.showModal = this.config.showMaterials;
    this.indexMaterial = this.config.currentIndex;
  },
  computed: {
    go(): GoToRoute {
      return new GoToRoute();
    },
    user(): User {
      return getUserFromStorage();
    },
  },
  methods: {
    onChooseMaterial(value: number) {
      this.indexMaterial += value;
      if (this.indexMaterial < 0) this.indexMaterial = 0;
      this.$emit(
        "onChooseMaterial",
        this.learningObjective,
        this.indexMaterial
      );
      // this.indexMaterial = 0;
    },
    changeMaterial(value: number) {
      this.indexMaterial += value;
      if (this.indexMaterial < 0) this.indexMaterial = 0;
    },
    onCloseMaterialsModal() {
      this.$emit("onCloseMaterialsModal");
    },
    onGoToObjective(): void {
      let courseId = this.$route.params.id;
      this.$emit(
        "onGoToObjective",
        courseId,
        this.learningObjective?.chapter,
        this.learningObjective?.id
      );
    },
    onGoToEditObject() {
      this.$emit("onGoToEditObject", this.materials[this.indexMaterial]);
    },
    onDeleteObject() {
      this.$emit("onDeleteObject", this.materials[0]);
    },
  },
});
</script>
